import { ItemsTable } from "@/components/items/ItemsTable";
import { PageHeader } from "@/components/shared/page-header";

export function ItemsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Items" />
      <ItemsTable />
    </div>
  );
}
